import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-8">Terms & Conditions</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: July 2026</p>

        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Pinaka Education (pinakaclasses.com), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our platform.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">2. Services</h2>
            <p>
              Pinaka Education provides online test series for competitive exam preparation (JEE, NEET, Board exams). Our services include practice tests, performance analytics, and study materials available through paid subscriptions and free trials.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">3. User Accounts</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>You must provide accurate and complete information during registration.</li>
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
              <li>One account per individual. Sharing accounts is not permitted.</li>
              <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">4. Payments & Pricing</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>All prices are in Indian Rupees (INR) and inclusive of applicable taxes.</li>
              <li>Payments are processed securely through Razorpay.</li>
              <li>Once purchased, test series access is granted immediately.</li>
              <li>We reserve the right to change pricing at any time without prior notice.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">5. Intellectual Property</h2>
            <p>
              All content on this platform — including questions, solutions, test series, and design — is the intellectual property of Pinaka Education. Reproducing, distributing, or sharing our content without written permission is strictly prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">6. Prohibited Conduct</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Using automated tools to access or scrape content.</li>
              <li>Sharing test questions or answers publicly.</li>
              <li>Attempting to hack, exploit, or disrupt the platform.</li>
              <li>Impersonating other users or providing false information.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">7. Limitation of Liability</h2>
            <p>
              Pinaka Education is not liable for any indirect, incidental, or consequential damages arising from use of our platform. We do not guarantee specific exam results or outcomes.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">8. Modifications</h2>
            <p>
              We may update these terms at any time. Continued use of the platform after changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-outfit font-semibold text-foreground mb-3">9. Contact</h2>
            <p>
              For questions about these terms, contact us at{' '}
              <a href="mailto:support@pinakaclasses.com" className="text-primary hover:underline">
                support@pinakaclasses.com
              </a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
